import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-x-close',
  imports: [],
  templateUrl: './x-close.html',
  styleUrl: './x-close.scss',
})
export class XClose {
  stroke = input('#797674');
  width = input('1rem');
  height = input('1rem');
}
